<template>
  <div>
    <div class="shippingHistoryTable">
      <v-data-table
        :headers="headersTmp"
        :items="propsItems"
        :item-key="itemKey"
        :hide-default-header="false"
        hide-default-footer
        class="rounded-lg"
        :items-per-page="-1"
        :no-data-text="$t('common.common_no-history')"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-if="!items.length">
              <td :colspan="headersTmp.length" class="text-center">
                {{ $t('sale.sale_not-product') }}
              </td>
            </tr>
            <template v-for="(item, trIndex) in items">
              <tr
                v-for="(rackItem, rackIndex) in item.rackProductList"
                :key="`${trIndex}-${rackIndex}`"
              >
                <td
                  v-if="rackIndex === 0"
                  :rowspan="item.rackProductList.length"
                  width="135px"
                  class="text-center"
                >
                  {{ getProductInfo(item.product_id).product.productNumber }}
                </td>
                <td
                  v-if="rackIndex === 0"
                  :rowspan="item.rackProductList.length"
                >
                  {{ getProductInfo(item.product_id).product.nameJp }} <br />
                  {{ getProductInfo(item.product_id).product.nameCn }}
                </td>
                <td
                  v-if="rackIndex === 0"
                  :rowspan="item.rackProductList.length"
                  class="text-center"
                >
                  {{ getProductCapacity(item.product_id) }}
                </td>
                <td class="text-center">{{ rackItem.quantity }}</td>
                <td class="text-center">
                  {{ rackItem.estimated_shipping_date }}
                </td>
                <td class="text-center">{{ rackItem.delivery_date }}</td>
              </tr>
            </template>
          </tbody>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <NormalButton
            :text="$t('payment.payment_sale-payment-cancel')"
            height="32px"
            width="120px"
            color="white"
            textColor="thinText--text"
            :outlined="true"
            @click="cancel(item)"
          />
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import NormalButton from '@/components/items/Buttons/NormalButton'
export default {
  name: 'ShippingHistoryTable',
  components: {
    NormalButton
  },
  props: {
    headers: [],
    propsItems: {
      type: Array,
      require: true,
      default: () => []
    },
    recItems: {
      type: Object,
      require: true,
      default: () => []
    },
    itemKey: String
  },
  data: () => ({
    paymentIdName: ''
  }),
  created() {},
  methods: {
    cancel(id) {
      this.$emit('cancel', id)
    },
    getProductMoveIndex(productId) {
      return this.recItems.productMoves.findIndex(
        (ele) => ele.product.productId === productId
      )
    },
    getProductInfo(productId) {
      const productMoveIndex = this.getProductMoveIndex(productId)
      return this.recItems.productMoves[productMoveIndex]
    },
    getProductCapacity(productId) {
      const productInfo = this.getProductInfo(productId)
      return productInfo.product.capacity ? productInfo.product.capacity : '-'
    }
  },
  computed: {
    headersTmp() {
      if (!Array.isArray(this.headers)) {
        return []
      }
      const headersTmp = this.headers.map((header) => {
        if (!this.isOperation) {
          if (header.value === 'operationId') {
            header.text = ''
            header.value = 'noDisplay'
          }
        }
        const tmp = { ...header }
        tmp.text = this.$t(tmp.text)
        return tmp
      })
      return headersTmp
    },
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.shippingHistoryTable {
  ::v-deep .v-data-table {
    th {
      background-color: rgba(151, 198, 234, 0.1);
      padding-left: 30px;
      border-collapse: collapse;
      text-align: center !important;
      white-space: pre-wrap;
      background-color: #fafafb;

      border-bottom: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
    }
    td {
      padding-left: 30px;
      border-collapse: collapse;

      border-bottom: 1px solid #d8d8d8;
      border-right: 1px solid #d8d8d8;
      border-spacing: 0;
      margin: -1px;
    }
  }
}
.normalNumberInput {
  width: 180px;
}
</style>
